/* Responsibility: Wrapper for a query url library, making it possible to get query param and setting query param. */
import Url from './url.js';

export default function (url) {
    const _url = new Url(url);
    return {
        queryParameter(name) {
            return _url.query[name];
        },
        queryParameters() {
            return _url.query;
        },
        setQueryParameter(name, value) {
            _url.query[name] = value;
            return this;
        },
        toString() {
            return _url.toString();
        },
        deleteQueryParameter(name) {
            delete _url.query[name];
            return this;
        },
    };
}
